module.exports = __webpack_public_path__ + "img/slolution-5.02bdf4c.png";